import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';
import { NativeWindowService } from '../../../core/service/native-window.service';

@Injectable()
export class InvoiceExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: InvoiceService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === invoiceCommand.export && command.itemsSource.length > 0;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }
  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.export(command.items.map(item => item.id)).pipe(
        map(file => {
          this._nativeWindow.save(file);
          return true;
        })
      );
    }
    if (command instanceof FilteredCommand) {
      return this._dataService
        .exportFilter(command.filterProvider.filterState, command.includedIds, command.excludedIds, command.totalAffectedItemsControlValue)
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
            return true;
          })
        );
    }
  }
}
